<template>
  <box-default>
    <div class="col-xs-12">
      <div class="default-box pi-page">
        <h1 class="pi-page__title">Product Intelligence</h1>
        <form class="pi-unlock" @submit.prevent="submit">
          <label class="pi-unlock__label" for="pi-unlock-password">Senha de acesso</label>
          <p class="pi-unlock__hint">Digite a senha para abrir o Product Intelligence. Ela fica lembrada neste navegador por 30 dias.</p>
          <div class="pi-unlock__row">
            <input id="pi-unlock-password" ref="password" v-model="password" type="password" class="form-control pi-input"
                   autocomplete="off" :aria-invalid="wrong ? 'true' : 'false'" aria-describedby="pi-unlock-error">
            <button type="submit" class="btn btn-primary" :disabled="!password">Entrar</button>
          </div>
          <p id="pi-unlock-error" class="pi-unlock__error" role="alert">{{ wrong ? 'Senha incorreta.' : '' }}</p>
        </form>
      </div>
    </div>
  </box-default>
</template>

<script>
import boxDefault from "../../components/layouts/boxDefault.vue";
import { browserStorage, isUnlocked, safeRedirect, unlock } from "../../components/pi/piUnlock.js";

export default {
  name: "pi-unlock",
  components: { boxDefault },
  data() {
    return {
      password: "",
      wrong: false,
    };
  },
  computed: {
    target() {
      return safeRedirect(this.$route.query.redirect);
    },
  },
  created() {
    if (isUnlocked(browserStorage(), Date.now())) this.$router.replace(this.target);
  },
  mounted() {
    if (this.$refs.password) this.$refs.password.focus();
  },
  methods: {
    submit() {
      if (unlock(browserStorage(), this.password, Date.now())) {
        this.wrong = false;
        this.$root.$emit("pi-unlocked");
        this.$router.replace(this.target);
        return;
      }
      this.wrong = true;
      this.password = "";
    },
  },
};
</script>

<style src="../../components/pi/pi.css"></style>

<style scoped>
.pi-unlock {
  max-width: 420px;
  margin: 24px 0;
}

.pi-unlock__label {
  display: block;
  font-weight: 600;
  color: #3a424e;
}

.pi-unlock__hint {
  margin: 4px 0 12px;
  font-size: 12px;
  color: #6b7280;
}

.pi-unlock__row {
  display: flex;
  gap: 8px;
}

.pi-unlock__error {
  min-height: 18px;
  margin: 8px 0 0;
  font-size: 12px;
  color: #a3172b;
}
</style>



// WEBPACK FOOTER //
// src/vue/pages/restricted/piUnlock/piUnlock.vue